<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp; Employee</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mb-4"> Employee </h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <div class="col-lg-3 col-sm mobile-div">
                      <input type="text" class="form-control form-control-sm" v-model="searchEmployeeName" placeholder="Employee Name">
                    </div>
                    <div class="col-lg-3 col-sm mobile-div">
                      <input type="text" class="form-control form-control-sm" v-model="searchEmployeeEmail" placeholder="Employee Email">
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <select class="form-control form-control-sm" data-toggle="dropdown" name="status" v-model="searchUserType">
                        <option value="">All Type</option>
                        <option value="3">Courier</option>
                        <option value="4">Technician</option>
                        <option value="5">Internal</option>
                      </select>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <vue-select :options="divisionSearch" v-model="searchDivision" placeholder="All Division" :deselectFromDropdown="true" :searchable="false"/>
                      <!-- <select class="form-control form-control-sm" data-toggle="dropdown" name="status" v-model="searchDivision" v-for="divisionSearch">
                        <option value="">All Division</option>
                        <option value="Product">Product</option>
                        <option value="Bussiness">Bussiness</option>
                      </select> -->
                    </div>
                    <div class="col-lg-2 col-sm d-flex mobile-div" style="gap: 10px;">
                      <button class="btn btn-primary btn-sm" @click="searchData" style="height: fit-content;"> Search </button>
                      <button class="btn reset-btn" @click="resetSearch">Reset</button>
                    </div>
                  </div>
                </div>
                <router-link to="/employee/create" class="btn btn-primary btn-sm mb-1" @click="openModal('AddEmployee')"> Add New Employee </router-link>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th style="width: 140px;">Employee Name</th>
                      <th style="width: 200px;">Email</th>
                      <th style="width: 100px;">Join Date</th>
                      <th style="width: 100px;">Birth Date</th>
                      <th>User Type</th>
                      <th>Division</th>
                      <th>Status</th>
                      <th style="text-align: center; width: 160px;">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable === true">
                      <td colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="(data, index) in dataUser" :key="`user-${index}`">
                      <td>{{ data.userName }}</td>
                      <td style="word-break: break-all;">{{ data.userEmail }}</td>
                      <td>{{ data.userJoinDate }}</td>
                      <td>{{ data.userBirthDate }}</td>
                      <td v-if="data.userType ==1"> Lesee </td>
                      <td v-if="data.userType ==2"> Lessor </td>
                      <td v-if="data.userType ==3"> Courier </td>
                      <td v-if="data.userType ==4"> Technician </td>
                      <td v-if="data.userType ==5"> Internal </td>
                      <td>{{ data.userDivision }}</td>
                      <td v-if="data.userStatus == 1"><label class="badge badge-success">Active</label></td>
                      <td v-if="data.userStatus == 0"><label class="badge badge-danger">Inacive</label></td>
                      <td>
                        <div class="d-flex justify-content-center align-items-center" style="gap: 10px;">
                          <button class="btn icon-btn icon-btn-blue" @click="toPageId(data.userId)"><img src="~@/assets/icon/pencil-edit-blue.svg" alt="pencil edit icon"></button>
                          <button class="btn icon-btn icon-btn-orange" @click="openModal('ChangeStatus', data.userId , data.userStatus, data.userName)"><img src="~@/assets/icon/change-orange.svg" alt="change icon"></button>
                          <button class="btn icon-btn icon-btn-yellow" @click="openModal('ResetPass', data.userId,'',data.userName)"><img src="~@/assets/icon/reset-password-yellow.svg" alt="reset password icon"></button>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="totalData === 0 && loadingTable === false">
                      <td colspan="8" class="text-center"> Data Not Available</td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- modalAddEmployee -->
      <div class="modal fade" id="modalAddEmployee" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Add Employee </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                     <div class="one-line">
                        <label class="ol-label"> FullName </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="name" class="form-control" :class="{ 'form-control border-red' : $v.addFullName.$error}" v-model.trim="$v.addFullName.$model">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Email </label>
                        <label class="ol-titik2">:</label>
                        <input type="email" name="email" class="form-control" :class="{ 'form-control border-red' : $v.addEmail.$error}" v-model.trim="$v.addEmail.$model">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Phone Number </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="phone_number" class="form-control" :class="{ 'form-control border-red' : $v.addPhoneNumber.$error}"  v-model.trim="$v.addPhoneNumber.$model">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Birth Date </label>
                        <label class="ol-titik2">:</label>
                        <input type="date" name="birth_date" class="form-control"  :class="{ 'form-control border-red' : $v.addBirthDate.$error}" v-model.trim="$v.addBirthDate.$model">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Join Date </label>
                        <label class="ol-titik2">:</label>
                        <input type="date" name="join_date" class="form-control" :class="{ 'form-control border-red' : $v.addJoinDate.$error}" v-model.trim="$v.addJoinDate.$model">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Type </label>
                        <label class="ol-titik2">:</label>
                        <select name="qty" class="form-control"  :class="{ 'form-control border-red' : $v.addUserType.$error}" v-model.trim="$v.addUserType.$model">
                          <option value="">Select Type</option>
                          <option value="3"> Courier </option>
                          <option value="4"> Technician </option>
                          <option value="5"> Internal </option>
                        </select>
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Division </label>
                        <label class="ol-titik2">:</label>
                        <multiselect
                            v-model="addDivision"
                            :options="divisionOption"
                            :allow-empty="false"
                            :select-label="''"
                            :deselect-label="''"
                            placeholder="Select Division"
                            :class="{'error-field' : $v.addDivision.$error}"
                        ></multiselect>
                    </div>
                    <div class="one-line">
                        <label class="ol-label">Work Location </label>
                        <label class="ol-titik2">:</label>
                        <multiselect
                            v-model="region"
                            :options="warehouseRegionList"
                            :allow-empty="false"
                            :select-label="''"
                            :deselect-label="''"
                            :multiple="true"
                            placeholder="Select work location"
                            :class="{'error-field' : $v.region.$error}"
                        ></multiselect>
                    </div>
                    <div class="one-line" v-if="addUserType == 5">
                        <label class="ol-label-roles"> Roles </label>
                        <label class="ol-titik2">:</label>
                        <div class="roles">
                          <div v-for="(data,index) in dataPermission" :key="`permission-${index}`">
                            <div class="roles-menu" v-if="data.type == 'menu'">
                              <input type="checkbox" :id="data.permission" :name="data.cek" :value="data.permission" v-model="addRoles" @click="cekAll(data.cek,'0',data.permission)"> {{ data.name }}
                            </div>
                            <div class="roles-sub-menu" v-else-if="data.type == 'sub'">
                              <input type="checkbox" :name="data.cek" :id="data.permission" :value="data.permission" v-model="addRoles"  @click="cekAll(data.cek,'1',data.permission)"> {{ data.name }}
                            </div>
                            <div class="roles-sub-menu" v-else-if="data.type == 'sub-edit'">
                              <input type="checkbox" :name="data.cek" :id="data.permission" :value="data.permission" v-model="addRoles"  @click="cekAll(data.cek,'2',data.permission)"> {{ data.name }}
                            </div>
                          </div>
                        </div>
                    </div> 
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Save</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalEditEmployee -->
      <div class="modal fade" id="modalChangeStatus" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Change Status</h4>
                        <h5 class="modal-title">{{ modalEmployeeName }}</h5>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Status </label>
                        <label class="ol-titik2">:</label>
                        <select name="status" class="form-control form-control-sm" v-model="modalEmployeeStatus">
                          <option value="0">Inactive</option>
                          <option value="1">Active</option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="submitChangeStatus" v-if="loadingButtonChange == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Save</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalEditEmployee -->
      <div class="modal fade" id="modalResetPass" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Reset Password</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <p>Are you sure to reset password {{ modalEmployeeName }}?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-warning btn-sm" @click="submitResetPassword" v-if="loadingButtonReset == false">Reset</button>
                    <button type="button" class="btn btn-warning btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Reset</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import SideBar from '../SideBar'
import { required, minLength, between,numeric, email } from 'vuelidate/lib/validators'
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import vueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
export default {
  name: 'EmployeeSearchPage',
  components:{
    SideBar,
    Multiselect,
    vueSelect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      dataUser: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      orderId:"",
      companyName:"",
      statusOrder:"",
      loadingTable: true,
      loadingButtonChange:false,
      loadingButtonReset:false,
      loadingButtonAdd:false,
      employeeName:"",
      employeeEmail:"",
      employeeDivision:"",
      employeePilih:"",
      roles:[],
      searchEmployeeName:"",
      searchEmployeeEmail:"",
      searchUserType:"",
      searchDivision:"",
      dataPermission:[],
      addFullName:"",
      addEmail:"",
      addPhoneNumber:"",
      addBirthDate:"",
      addJoinDate:"",
      addUserType:"",
      addDivision:"",
      region:[],
      addRoles:[],
      modalEmployeeId:"",
      modalEmployeeStatus:"",
      modalEmployeeName:"",
      divisionOption:[],
      divisionSearch:[],
      warehouseRegionList:[],
    }
  },
  validations: {
    addFullName: {
      required
    },
    addEmail: {
      required,
      email
    },
    addPhoneNumber:{
      required,
      minLength: minLength(10),
      numeric
    },
    addBirthDate:{
      required
    },
    addJoinDate:{
      required
    },
    addUserType:{
      required
    },
    addDivision:{
      required
    },
    region:{
      required
    }
  },
  methods: {
    resetSearch(){
      this.$router.push('/employee/search?employeeName=&employeeEmail=&userType=&division=&page=1')
    },
     getPermissionList(){
      this.$http.get(process.env.GET_EMPLOYEE_PERMISSION_LIST,{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 200) {
          let sortedDataPermission = response.data.content.sort(function(a, b){return a.permission - b.permission});
 
          this.dataPermission = sortedDataPermission
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    getDivision(){
        this.$http.get(process.env.GET_EMPLOYEE_DIVISION,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 200) {
            this.divisionOption = response.data.content
            this.divisionSearch = this.divisionOption
          }
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    getWarehouseList(){
        this.$http.get(process.env.GET_CHILD_WAREHOUSE,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          
          if (response.data.status == 200) {
            this.warehouseRegionList = response.data.content
          }
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
     submitResetPassword(){
      this.loadingButtonReset = true
        this.$http.post(process.env.RESET_PASSWORD,{
          userId: this.modalEmployeeId,
          adminId: this.adminId
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 200) {
            swal("Success", this.modalEmployeeName+ " password has been reset sucessfully.  new password 'Asaninumber1' ", "success", {
              button: "Ok",
            })
          }
          $('#modalResetPass').modal('hide')
          this.loadingButtonReset = false
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    submitChangeStatus(){
      this.loadingButtonChange = true
        this.$http.post(process.env.CHANGE_USER_STATUS,{
          userId: this.modalEmployeeId,
          newStatus: parseInt(this.modalEmployeeStatus),
          adminId: this.adminId
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 200) {
            swal("Success", "Status has been successfully changed", "success", {
              button: "Ok",
            })
          }
          $('#modalChangeStatus').modal('hide')
          this.getUser()
          this.loadingButtonChange = false
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    validateForm(){
      this.$v.$touch()
      if(!this.$v.$invalid){
        if (this.addPhoneNumber.substring(0,3)!= '628') {
          swal("Sorry", "Phone Number must be '628' at first", "error", {
              button: "Ok",
          })
        }else{
          if(this.addUserType == 5){
            if (this.addDivision == '') {
              swal("Sorry", "Division must be choose", "error", {
                  button: "Ok",
              })
            }else if(this.addRoles==''){
              swal("Sorry", "roles must be pick at least 1", "error", {
                button: "Ok",
              })
            }else{
              this.submitAddEmployee()
            }
          }else if(this.addUserType == 4){
            if (this.addDivision == '') {
              swal("Sorry", "Division must be choose", "error", {
                  button: "Ok",
              })
            }else{
              this.submitAddEmployee()
            }
          }else{
              this.submitAddEmployee()
          }
        }
      }
    },
    submitAddEmployee(){
      this.loadingButtonAdd = true
        this.$http.post(process.env.CREATE_EMPLOYEE,{
          fullName: this.addFullName.replace(this.spaceRegex, ' '),
          email: this.addEmail.replace(this.spaceRegex, ' '),
          phoneNumber: this.addPhoneNumber.replace(this.spaceRegex, ' '),
          birthDate: this.addBirthDate,
          joinDate: this.addJoinDate,
          userType: this.addUserType,
          division: this.addDivision,
          region: this.region,
          selectRoles: this.addRoles,
          adminId: this.adminId
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }else{
            $('#modalAddEmployee').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getUser()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    toPageId(x){
      this.$router.push('/employee/edit/'+x)
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10.1'){
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
    searchData(){
      this.$router.push({path:'/employee/search', query: {
            employeeName: this.searchEmployeeName,
            employeeEmail: this.searchEmployeeEmail,
            userType: this.searchUserType,
            division: this.searchDivision,
            page:1
          }
      })
      this.getUser()
    },
    toDataPage(pagePost){
      this.$router.push({path:'/employee/search', query: {
            employeeName: this.searchEmployeeName,
            employeeEmail: this.searchEmployeeEmail,
            userType: this.searchUserType,
            division: this.searchDivision,
            page:pagePost
          }
      })
      this.getUser()
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    openModal(x,y,z,a) {
      this.modalEmployeeId = y
      this.modalEmployeeStatus = z
      this.modalEmployeeName = a
      $("#modal"+x).modal('show')
    },
    getUser(){
      this.loadingTable = true
      this.searchEmployeeName = this.$route.query.employeeName
      this.searchEmployeeEmail =this.$route.query.employeeEmail
      this.searchUserType =this.$route.query.userType
      this.searchDivision = this.$route.query.division
      this.currentPage = parseInt(this.$route.query.page)
      this.$http.post(process.env.SEARCH_USER,{
        employeeName: this.$route.query.employeeName.replace(this.spaceRegex, ' '),
        employeeEmail: this.$route.query.employeeEmail.replace(this.spaceRegex, ' '),
        userType: this.$route.query.userType,
        division: this.$route.query.division,
        page: parseInt(this.$route.query.page)
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
           })
        } else{
          this.dataUser = response.data.content.data
          this.totalPage = response.data.content.totalPage
          this.totalData = response.data.content.totalData
          this.currentPage = response.data.content.currentPage
              
          this.loadingTable = false
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    onlyUnique(value, index, self) { 
        return self.indexOf(value) === index;
    },
    removeA(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax= arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    },
    cekAll(x,y,z){
        if (document.getElementById(z).checked) {
          var check = document.getElementsByName(x);
          if (y==2) {
            y=y-2
          }
          var jml=(check.length-y);
          var b=0;
          for (b=0;b<jml;b++)
            {
                check[b].checked=true;
                this.addRoles.push(check[b].value)
            }
          this.addRoles = this.addRoles.filter( this.onlyUnique );
        }else{
          var check = document.getElementsByName(x);
          if (y!=2) {
          var jml=(check.length);
          var b=0;
          for (b=0;b<jml;b++)
            {
                check[b].checked=false;
                this.removeA(this.addRoles, check[b].value)
            }
          this.addRoles = this.addRoles.filter( this.onlyUnique );
          }
        }
    }
  },
  created(){
    this.getUser()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
    this.getDivision()
    this.getPermissionList()
    this.getWarehouseList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .reset-btn {
    border: 1px solid #D1D9E2;
    color: #247FEC;
    font-weight: 600;
    height: fit-content;
    font-size: .875rem;
    padding: .25rem .5rem;
  }

  .error-field >>> .multiselect__tags{
    border-color: #f57f6c;
  }

.icon-btn {
  border-radius: 8px;
  padding: 4px;
  background: #ffffff;
  width: 34px;
}

.icon-btn-blue {
  border: 1px solid #247FEC66;
}

.icon-btn-orange {
  border: 1px solid #F2641966;
}

.icon-btn-yellow {
  border: 1px solid #B9A44C66;
}

.cekbox{
  margin-top: 6px;
  margin-right: 5px;
}

.roles{
  display: grid;
}

.roles-menu{
  display: flex;
}

.roles-sub-menu{
  display: flex;
  margin-left: 15px;
}

.one-line{
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label{
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles{
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price{
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}

.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.border-red{
  border-color:red;
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}
.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/EmployeeSearchPage.vue